export const EXTENSION_STYLES: Record<string, { backgroundColor: string; color: string }> = {
  PDF: { backgroundColor: "#FDECEC", color: "#C62828" },
  DOC: { backgroundColor: "#E8F0FF", color: "#1749D1" },
  DOCX: { backgroundColor: "#E8F0FF", color: "#1749D1" },
  TXT: { backgroundColor: "#E7F8EE", color: "#1D8F5A" },
  MD: { backgroundColor: "#F4ECFF", color: "#7A3FE0" },
  JSON: { backgroundColor: "#FFF4E5", color: "#B26A00" },
};
